<h2 mat-dialog-title>PAGINA DE EJEMPLO</h2>
<div mat-dialog-content>
<h1>formulario de pruebas</h1>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancelClick()"  >Cancelar</button>
  <button mat-button [mat-dialog-close]="data.name" cdkFocusInitial >Aceptar</button>
</div>

